export function getImageSize(numberOfCols: number, docWidth: number): string {
    return (docWidth / numberOfCols).toFixed();
}

export function getOptimizedImageURL(url: string, newSize): string {
    if (url) {
        const srcSize = url.substring(url.lastIndexOf('_') + 1, url.lastIndexOf('.'));
        if (['small', 'medium', 'large'].includes(srcSize)) {
            return url.replace(srcSize, newSize + "x");
        }
        return url.substr(0, url.lastIndexOf('_') + 1) + srcSize + '_' + newSize + "x" + url.substr(url.lastIndexOf('.'));
    }
}
